import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ParaphraseTexts from "../paraphrase/ParaphraseTexts";
import SectionWhyNeedParaphraser from "./SectionWhyNeedParaphraser";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";

function ParaphraseMain() {
  return (
    <div className="p-3">
      {/*Firebase analytics */}
      {logEvent(analytics, "Paraphrase Texts Screen")}

      {/*Add title and metadata */}
      <title>Paraphrasing tool : Rephrase sentences for free</title>
      <meta name="robots" content="index, follow"></meta>
      <link rel="canonical" href="https://humanizetexts.com/paraphrase" />
      <meta
        name="description"
        content="Our AI-powered paraphraser helps researchers, students and professionals rewrite, edit, and change the tone of their text to improve clarity and comprehension."
      ></meta>
      <meta
        name="keywords"
        content="paraphraser,paraphrase,paraphrasing tool,rephrase,rewrite,re phrase,rephrase sentences,100% accuracy,undetectable ai,zero ai,change tone of sentences,"
      ></meta>
      <meta
        property="og:title"
        content="Paraphrasing tool : Rephrase sentences for free"
      />
      <meta
        name="twitter:title"
        content="Paraphrasing tool : Rephrase sentences for free"
      ></meta>

      {/* NavBar component */}
      <NavBar />
      {/* Paraphrase texts */}
      <ParaphraseTexts />
      {/* Why we need paraphraser */}
      <SectionWhyNeedParaphraser />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default ParaphraseMain;
